module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_34.0496bd60.jpg";